import Vue from 'vue';
import VueCookies from 'vue-cookies';

Vue.use(VueCookies);

export default {
    viewedOffersIds: Vue.$cookies.get('viewedOffersIds') != undefined ? Vue.$cookies.get('viewedOffersIds') : []
};
